module.exports = __webpack_public_path__ + "assets/img/page1.dd4fb8fb.png";